import { render } from "./AlertRuleSidebar.vue?vue&type=template&id=1db031d1&ts=true"
import script from "./AlertRuleSidebar.vue?vue&type=script&lang=ts"
export * from "./AlertRuleSidebar.vue?vue&type=script&lang=ts"

import "./AlertRuleSidebar.vue?vue&type=style&index=0&id=1db031d1&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__